/**
 * Horário de Brasília para as telas da ADM, independente do fuso da máquina de
 * quem está usando — o servidor grava em UTC.
 *
 * Recorte do utils/brtDateTime.ts do RadExperts: só o que a tela de aceites
 * usa. O Brasil não tem horário de verão desde 2019, então America/Sao_Paulo é
 * UTC-03:00 o ano inteiro. Se isso mudar, é este arquivo que muda.
 */

/** Offset fixo de America/Sao_Paulo. */
export const BRT_OFFSET_MINUTES = -180;

/** Data (`2026-08-28`) e hora (`08:00`) em Brasília de um instante UTC. */
export function utcIsoToBrtFields(iso?: string | Date | null): {
  date: string;
  time: string;
} {
  if (!iso) return { date: '', time: '' };

  const parsed = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(parsed.getTime())) return { date: '', time: '' };

  // Deslocar o instante para BRT e ler os campos em UTC: evita depender do fuso
  // da máquina de quem está usando a ADM.
  const shifted = new Date(parsed.getTime() + BRT_OFFSET_MINUTES * 60 * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');

  return {
    date: `${shifted.getUTCFullYear()}-${pad(shifted.getUTCMonth() + 1)}-${pad(shifted.getUTCDate())}`,
    time: `${pad(shifted.getUTCHours())}:${pad(shifted.getUTCMinutes())}`,
  };
}

/** `28/08/2026 08:00` — como a data aparece nas tabelas da ADM. */
export function formatBrtDateTime(iso?: string | Date | null): string {
  const { date, time } = utcIsoToBrtFields(iso);
  if (!date) return '';

  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year} ${time}`;
}
